import { action, computed, makeObservable, observable } from 'mobx';
import toast from 'react-hot-toast';
import URLConstants from '../../constants/url-constants';
import config from '../../helpers/config-helper';
import { getTenantIdFromLocalStorage } from '../../helpers/localstorage-helper';
import { IOption } from '../../models/ICommon';
import {
  IBaseAIMSDetails,
  IPortalListVM,
} from '../../models/response/IAimsResponse';
import IApiResponse, {
  IApiSuccessResponse,
} from '../../models/response/IApiResponse';
import { IAimsPortalState } from '../../models/state/IAimsPortalState';
import { formatMessage } from '../../translations/format-message';
import { GetAllPortalState, ObservableInitialState } from '../initialState';
import * as baseService from '../service/base-service';
const appConfig = config();

export class AIMSPortalStore implements IAimsPortalState {
  initialStateValue = ObservableInitialState;
  portalList: IPortalListVM = GetAllPortalState;
  getAllPortalState = { ...this.initialStateValue };
  addUpdatePortalState = { ...this.initialStateValue };

  constructor() {
    makeObservable(this, {
      portalList: observable,
      getAllPortalState: observable,
      GetPortalListService: action,
      resetPortalList: action,
      AddPortalService: action,
      resetAddUpdatePortalState: action,
      allAvailablePortals: computed,
      addUpdatePortalState: observable,
      getAimsDetails: computed,
    });
  }

  //#region Actions
  GetPortalListService = () => {
    this.getAllPortalState.inProgress = true;
    const url =
      URLConstants.GetAllPortalList +
      `?TenantId=${getTenantIdFromLocalStorage()}`;
    return baseService
      .getRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<IPortalListVM>>) => {
        if (response.data.Error) {
          this.getAllPortalState.error = response.data.Message;
          toast.error(formatMessage(response.data.Message));
        } else {
          this.portalList = response.data.Data;
          this.getAllPortalState.success = true;
        }
      })
      .catch((err: string) => {
        this.getAllPortalState.error = err;
      })
      .finally(
        action(() => {
          this.getAllPortalState.inProgress = false;
        })
      );
  };

  AddPortalService = (data: IBaseAIMSDetails) => {
    this.addUpdatePortalState.inProgress = true;
    const url = URLConstants.AddPortal;
    return baseService
      .postRequest(url, data)
      .then((response: IApiResponse<IApiSuccessResponse<boolean>>) => {
        if (response.data.Error) {
          this.addUpdatePortalState.error = response.data.Message;
        } else {
          this.addUpdatePortalState.success = true;
        }
      })
      .catch((err: string) => {
        this.addUpdatePortalState.error = err;
      })
      .finally(
        action(() => {
          this.addUpdatePortalState.inProgress = false;
        })
      );
  };
  //#endregion

  //#region Computed
  get allAvailablePortals(): IOption[] {
    const portalOptions: IOption[] = [
      {
        id: -1,
        value: 'please_select',
        disabled: true,
      },
    ];
    if (this.portalList?.AIMSs && this.portalList.AIMSs?.length > 0) {
      this.portalList.AIMSs.map((portal) => {
        portalOptions.push({
          id: portal.Id,
          value: portal.TemplateName,
          disabled: false,
        });
      });
    }
    return portalOptions;
  }

  get getAimsDetails(): IBaseAIMSDetails {
    if (this.portalList && this.portalList?.AIMSDetails) {
      const {
        DeadlineCrossTemplateId,
        NearDeadLineDate,
        NearDeadlineTemplateId,
        PatternForMissingPartTemplateId,
        RegularModeTemplateId,
        StationCode,
        TenantId,
        Url,
        Id,
      } = this.portalList.AIMSDetails;
      return {
        DeadlineCrossTemplateId: DeadlineCrossTemplateId.toString(),
        NearDeadlineTemplateId: NearDeadlineTemplateId.toString(),
        RegularModeTemplateId: RegularModeTemplateId.toString(),
        PatternForMissingPartTemplateId:
          PatternForMissingPartTemplateId.toString(),
        NearDeadLineDate: NearDeadLineDate,
        Url: Url,
        StationCode: StationCode,
        Id: Id,
        TenantId: TenantId,
      };
    }
    return {
      DeadlineCrossTemplateId: '-1',
      NearDeadlineTemplateId: '-1',
      RegularModeTemplateId: '-1',
      PatternForMissingPartTemplateId: '-1',
      NearDeadLineDate: 0,
      Url: '',
      StationCode: '',
      Id: -1,
      TenantId: -1,
    };
  }
  //#endregion

  //#region Reset
  resetPortalList = () => {
    this.portalList = GetAllPortalState;
  };

  resetAddUpdatePortalState = () => {
    this.addUpdatePortalState = { ...this.initialStateValue };
  };

  //#endregion
}

export default new AIMSPortalStore();
